import { render, staticRenderFns } from "./classBadge.vue?vue&type=template&id=4a9df934&scoped=true&"
import script from "./classBadge.vue?vue&type=script&lang=js&"
export * from "./classBadge.vue?vue&type=script&lang=js&"
import style0 from "./classBadge.vue?vue&type=style&index=0&id=4a9df934&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9df934",
  null
  
)

export default component.exports